import { oneMembershipDomainFetchye } from '@americanexpress/consumer-travel-base';
import { getActiveLocaleSelector, getIsLoggedInSelector } from '@americanexpress/travel-selectors';
import { isConditionalFeature } from '@americanexpress/conditional-features';
import { MODULE_NAME } from '../constants/modules';
import { hasVacationRentalsRule } from '../constants/featureRulesConstants';
import { PERSONA_API_FF } from '../constants/oneXpConstants';
import { usePrefetchedFeatureFlagWithProperties } from './useFeatureFlagWithProperties';
import { MEMBERSHIP_QUERY } from '../graphql/membership';

export const loadMembershipDomain = (state) => async (dispatch) => {
  const isLoggedIn = getIsLoggedInSelector(state);
  const isVacationRentalsEnabledLocale = isConditionalFeature(hasVacationRentalsRule, state);
  const activeLocale = getActiveLocaleSelector(state);
  const hasPersona = usePrefetchedFeatureFlagWithProperties(PERSONA_API_FF, state);

  if (!isLoggedIn || activeLocale !== 'en-US' || (!isVacationRentalsEnabledLocale && !hasPersona)) return;

  const fetcherOpts = {
    reporting: {
      moduleID: MODULE_NAME,
      componentID: 'loadMembershipDomain',
      fetch: {
        activeLocale,
      },
    },
    locale: activeLocale,
  };

  await dispatch(oneMembershipDomainFetchye(
    { query: MEMBERSHIP_QUERY },
    {},
    fetcherOpts
  ));
};
